export default __webpack_public_path__ + "static/media/eye-filled-lime.4755e727.svg";